export var EXPLORE_WATCHLIST_SCHEMES = "EXPLORE_WATCHLIST_SCHEMES";
export var EXPLORE_BOOKMARK_SCHEMES = "EXPLORE_BOOKMARK_SCHEMES";
export var EXPLORE_BOOKMARK_SCHEMES_SP = "EXPLORE_BOOKMARK_SCHEMES_SP";
export var EXPLORE_BOOKMARK_SCHEMES_NCD = "EXPLORE_BOOKMARK_SCHEMES_NCD";
export var EXPLORE_BOOKMARK_SCHEMES_BONDS = "EXPLORE_BOOKMARK_SCHEMES_BONDS";
export var EXPLORE_BOOKMARK_SCHEMES_UNLISTED_SHARES = "EXPLORE_BOOKMARK_SCHEMES_UNLISTED_SHARES";
export var EXPLORE_PRODUCT_RATING_FILTERS = "EXPLORE_PRODUCT_RATING_FILTERS";
export var EXPLORE_PRODUCT_INTERESTFREQUENCY_FILTERS = "EXPLORE_PRODUCT_INTERESTFREQUENCY_FILTERS";
export var EXPLORE_PRODUCT_MATURITYDATE_FILTERS = "EXPLORE_PRODUCT_MATURITYDATE_FILTERS";
export var EXPLORE_PRODUCT_ISSUERNAME_FILTERS = "EXPLORE_PRODUCT_ISSUERNAME_FILTERS";
export var EXPLORE_PRODUCT_PRICERANGE_FILTERS = "EXPLORE_PRODUCT_PRICERANGE_FILTERS";
export var EXPLORE_PRODUCT_COUPON_FILTERS = "EXPLORE_PRODUCT_COUPON_FILTERS";
export var EXPLORE_PRODUCT_TYPE_FILTERS = "EXPLORE_PRODUCT_TYPE_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_RATING_FILTERS = "EXPLORE_PRODUCT_LOCAL_RATING_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_MIN_INVESTMENT = "EXPLORE_PRODUCT_LOCAL_MIN_INVESTMENT";
export var EXPLORE_PRODUCT_LOCAL_AVAILABLE_QUANTITY = "EXPLORE_PRODUCT_LOCAL_AVAILABLE_QUANTITY";
export var EXPLORE_PRODUCT_MIN_INVESTMENT = "EXPLORE_PRODUCT_MIN_INVESTMENT";
export var EXPLORE_PRODUCT_AVAILABLE_QUANTITY = "EXPLORE_PRODUCT_AVAILABLE_QUANTITY";
export var EXPLORE_PRODUCT_LOCAL_INTERESTFREQUENCY_FILTERS = "EXPLORE_PRODUCT_LOCAL_INTERESTFREQUENCY_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_MATURITYDATE_FILTERS = "EXPLORE_PRODUCT_LOCAL_MATURITYDATE_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_ISSUERNAME_FILTERS = "EXPLORE_PRODUCT_LOCAL_ISSUERNAME_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_PRICERANGE_FILTERS = "EXPLORE_PRODUCT_LOCAL_PRICERANGE_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_COUPON_FILTERS = "EXPLORE_PRODUCT_LOCAL_COUPON_FILTERS";
export var EXPLORE_PRODUCT_LOCAL_TYPE_FILTERS = "EXPLORE_PRODUCT_LOCAL_TYPE_FILTERS";
export var EXPLORE_PRODUCT_DETAILS = "EXPLORE_PRODUCT_DETAILS";
export var EXPLORE_CASH_FLOW = "EXPLORE_CASH_FLOW";
export var EXPLORE_FUNDS_ERROR = "EXPLORE_FUNDS_ERROR";
export var EXPLORE_FUNDS_HIDE_ERROR = "EXPLORE_FUNDS_HIDE_ERROR";
export var UPDATE_SUB_CATEGORY_ID = "UPDATE_SUB_CATEGORY_ID";
export var UPDATE_WATCHLIST_REQUEST_PAYLOAD_ID = "UPDATE_WATCHLIST_REQUEST_PAYLOAD_ID";
export var UPDATE_BOOKMARK = "UPDATE_BOOKMARK";
export var UPDATE_ONBOARD_POPUP = "UPDATE_ONBOARD_POPUP";
export var EXPLORE_PRODUCT_TABS = "EXPLORE_PRODUCT_TABS";
export var EXPLORE_USER_POPUP_STATUS = "EXPLORE_USER_POPUP_STATUS";
export var EXPLORE_USER_POPUP_STATUS_SAVE = "EXPLORE_USER_POPUP_STATUS_SAVE";
export var EXPLORE_DRAFT_ORDERS = "EXPLORE_DRAFT_ORDERS";
export var EXPLORE_DRAFT_COUNT = "EXPLORE_DRAFT_COUNT";
export var RESET_VALUE_FILTER = "RESET_VALUE_FILTER";
export var MULTI_UPDATE_BOOKMARK = "MULTI_UPDATE_BOOKMARK";
export var UPDATE_NCD_REQUEST_PAYLOAD_ID = "UPDATE_NCD_REQUEST_PAYLOAD_ID";
export var UPDATE_BONDS_REQUEST_PAYLOAD_ID = "UPDATE_BONDS_REQUEST_PAYLOAD_ID";
export var UPDATE_SP_REQUEST_PAYLOAD_ID = "UPDATE_SP_REQUEST_PAYLOAD_ID";
export var UPDATE_UNLISTED_REQUEST_PAYLOAD_ID = "UPDATE_UNLISTED_REQUEST_PAYLOAD_ID";
export var EXPLORE_DOWNLOAD_DATA = "EXPLORE_DOWNLOAD_DATA";
export var USER_UNAUTHORIZED = "USER_UNAUTHORIZED";
export var EXPLORE_PRODUCT_LOCAL_PRODUCT_TYPE = "EXPLORE_PRODUCT_LOCAL_PRODUCT_TYPE";
export var EXPLORE_PRODUCT_LOCAL_STATUS = "EXPLORE_PRODUCT_LOCAL_STATUS";
export var EXPLORE_PRODUCT_LOCAL_CLIENT_NAME = "EXPLORE_PRODUCT_LOCAL_CLIENT_NAME";
export var EXPLORE_PRODUCT_LOCAL_INVESTMENT_VALUE = "EXPLORE_PRODUCT_LOCAL_INVESTMENT_VALUE";
